import { createContext, useCallback, useState } from 'react';
import axios from 'axios';
import { wrap } from '@hilma/tools';
import { useLanguage } from '@hilma/netina2all';

import { FreeSaleStatus } from '../types';

export const ProfileFreeSaleLinkContext = createContext<string | null>(null);
export const FreeSaleStatusContext = createContext<FreeSaleStatus | null>(null);
export const GetFreeSaleContext = createContext<(() => Promise<void>) | null>(null);

const ProfileFreeSaleProvider: React.FC = ({ children }) => {
	const [freeSaleLink, setFreeSaleLink] = useState('');
	const [status, setStatus] = useState<FreeSaleStatus | null>(null);

	const language = useLanguage();

	const getFreeSale = useCallback(async () => {
		const response = await axios.get<{ status: FreeSaleStatus; link?: string }>('/api/station/free-sale');
		setStatus(response.data.status);
		if (response.data.link) setFreeSaleLink(`${window.location.origin}/${language}/free-sale/${response.data.link}`);
	}, [language]);

	return wrap(
		[ProfileFreeSaleLinkContext.Provider, { value: freeSaleLink }],
		[FreeSaleStatusContext.Provider, { value: status }],
		[GetFreeSaleContext.Provider, { value: getFreeSale }]
	)(children) as React.ReactElement;
}

export default ProfileFreeSaleProvider;